define(["require", "exports", "jquery", "knockout", "log", "../../utils/urls", "../../utils/tools", "../../models/TodoModel"], function (require, exports, $, ko, log, urls_1, tools, TodoModel) {
    "use strict";
    var TodoActions = /** @class */ (function () {
        function TodoActions() {
            this.editModel = ko.observable(new TodoModel());
        }
        TodoActions.prototype.editTodo = function (todoId, customerId) {
            var self = this;
            tools.editModal({
                title: todoId > 0 ? "Edit Task" : "Add Task",
                buttonTitle: "Save",
                type: "info",
                modalOptions: {},
                save: function (event, modal) {
                    $(event.currentTarget).button("loading");
                    self.saveTodo(event.currentTarget, modal);
                },
                opened: function (modal) {
                    var getModelCall = null;
                    if (todoId > 0) {
                        getModelCall = tools.ajaxGet({
                            url: urls_1.urls.getTodoById,
                            data: { id: todoId },
                            success: function (result) {
                                if (result.Success) {
                                    self.editModel(new TodoModel(result.Data));
                                }
                                else {
                                    log.error(result.Error);
                                }
                            }
                        });
                    }
                    else {
                        self.editModel(new TodoModel());
                        self.editModel().CustomerId(customerId);
                    }
                    // Get lookup data:
                    var getLookupData = tools.ajaxGet({
                        url: urls_1.urls.getTodoGetLookupData,
                        data: { customerId: customerId },
                        success: function (data) {
                            if (data.Success) {
                                self.lookupLists = data.Data.lookupLists;
                            }
                            else {
                                log.error(data.Error);
                            }
                        }
                    });
                    $.when(getLookupData, getModelCall).done(function (lookupData, data) {
                        $(modal).find(".modal-body").html("<div data-bind=\"template: { name: 'customertodo-edit-template', data: editModel }\"></div>");
                        ko.applyBindings(self, modal);
                        self.customerDropDownList = $("#CustomerId", modal).kendoComboBox({
                            autoBind: false,
                            valuePrimitive: true,
                            filter: "contains",
                            dataTextField: "Text",
                            dataValueField: "Id",
                            virtual: {
                                itemHeight: 26,
                                valueMapper: function (options) {
                                    $.ajax({
                                        url: "/LookupDataSources/GetRecordIndex",
                                        type: "GET",
                                        data: self.convertValues(options.value, "Customer", "Name"),
                                        success: function (response) {
                                            options.success(response.Data);
                                        }
                                    });
                                }
                            },
                            height: 250,
                            dataSource: {
                                transport: {
                                    read: {
                                        url: "/LookupDataSources/Customers",
                                        type: "POST",
                                        dataType: "json"
                                    }
                                },
                                schema: {
                                    model: {
                                        //id: "Id",
                                        fields: {
                                            Id: { type: "number" },
                                            Text: { type: "string" }
                                        }
                                    },
                                    data: function (response) { return response.Data; },
                                    total: "Total"
                                },
                                pageSize: 100,
                                serverPaging: true,
                                serverFiltering: true
                            },
                            dataBound: function () {
                                //$(window).trigger("resize");
                                log.log("dataBound");
                            },
                            change: function (e) {
                                log.log("change", e);
                                if (e.sender.dataItem()) {
                                    self.editModel().CustomerId(e.sender.dataItem().Id);
                                }
                                else {
                                    self.editModel().CustomerId(0);
                                }
                            }
                        }).data("kendoComboBox");
                        var defId = self.editModel().CustomerId();
                        self.customerDropDownList.value(defId);
                    });
                }
            });
        };
        TodoActions.prototype.convertValues = function (value, tableName, orderByColumn) {
            var data = {};
            value = $.isArray(value) ? value : [value];
            for (var idx = 0; idx < value.length; idx++) {
                data["values[" + idx + "]"] = value[idx];
            }
            data.tableName = tableName;
            data.orderByColumn = orderByColumn;
            return data;
        };
        TodoActions.prototype.saveTodo = function (btn, modal) {
            var self = this;
            var obj = tools.modelToFormData(self.editModel);
            obj["__RequestVerificationToken"] = $('#mainAntiForgeryTokenForm input[name="__RequestVerificationToken"]').val();
            tools.ajaxPost({
                url: "/ToDo/SaveTodo",
                data: obj
            }).done(function (result) {
                if (result.Success) {
                    tools.success("Changes updated successfully");
                    if (self.saveCallback) {
                        self.saveCallback();
                    }
                    $(modal).modal("hide");
                    return;
                }
                else {
                    tools.error(result.Error);
                }
            }).always(function () {
                $(btn).button("reset");
            });
        };
        TodoActions.prototype.deleteTodoConfirm = function (todoId) {
            var self = this;
            tools.confirmModal({
                title: "Delete Customer Task",
                text: "Are you sure you want to delete customer task item?",
                buttonTitle: "Delete",
                type: "danger",
                modalOptions: {}
            }, function (modal) {
                $(modal).modal("hide");
                self.deleteTodo(todoId);
            });
        };
        TodoActions.prototype.deleteTodo = function (todoId) {
            var self = this;
            var data = {
                id: todoId
            };
            data["__RequestVerificationToken"] = $('#mainAntiForgeryTokenForm input[name="__RequestVerificationToken"]').val();
            tools.ajaxPost({
                url: "/ToDo/DeleteTodoConfirmed",
                data: data
            }).done(function (result) {
                if (result.Success) {
                    tools.success("ToDo deleted successfully");
                    if (self.deleteCallback) {
                        self.deleteCallback();
                    }
                }
                else {
                    tools.error(result.Error);
                }
            });
        };
        return TodoActions;
    }());
    return TodoActions;
});
//# sourceMappingURL=todoActions.js.map


//////////////////
// WEBPACK FOOTER
// ./build/areas/todos/todoActions.js
// module id = 82
// module chunks = 2